import { css } from "@emotion/react";

export const page = css`
  width: 100vw;
  margin-left: calc(50% - 50vw);
  background: #f5f5f3;
  min-height: 100vh;
`;

export const inner = css`
  width: 100%;
  padding: 44px 56px 80px;

  @media (max-width: 1024px) {
    padding: 36px 24px 64px;
  }

  @media (max-width: 768px) {
    padding: 28px 16px 48px;
  }
`;

export const topBlock = css`
  margin-bottom: 42px;
  text-align: center;
`;

export const title = css`
  margin: 0 auto 48px;
  font-family: ui-serif, Georgia, "Times New Roman", serif;
  font-size: 25px;
  line-height: 1.1;
  font-weight: 200;
  text-transform: uppercase;
  text-align: center;
  color: #1f1f1f;
  border-bottom: 0.7px solid #1f1f1f;
  display: inline-block;
  // text-decoration: underline;
  // text-underline-offset: 8px;

  @media (max-width: 1024px) {
    font-size: 42px;
  }

  @media (max-width: 768px) {
    font-size: 30px;
  }
`;

export const filtersRow = css`
  display: flex;
  justify-content: flex-start;
`;

export const filterButton = css`
  min-width: 146px;
  height: 44px;
  padding: 0 22px;
  border: 1px solid rgba(31, 31, 31, 0.45);
  background: transparent;
  cursor: pointer;

  font-family: ui-serif, Georgia, "Times New Roman", serif;
  font-size: 18px;
  text-transform: uppercase;

  &:hover {
    background: #efede8;
  }
`;
export const sortButton = css`
  border: none;
  background: transparent;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #1f1f1f;

  &:hover {
    opacity: 0.6;
  }
`;
export const grid = css`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 56px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const card = css`
  display: block;
  text-decoration: none;
  color: inherit;
  border: 1px solid rgba(31, 31, 31, 0.14);
  background: #f5f5f3;

  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

export const imageWrap = css`
  position: relative;
  width: 100%;
  aspect-ratio: 1/1;
  overflow: hidden;
  background: #ece8e1;
`;

export const badge = css`
  position: absolute;
  top: 10px;
  right: 0;
  color: black;
  font-size: 10px;
  padding: 3px 8px;
  // border: 1px solid #1f1f1f;
  background: #f5f5f3;
`;

export const preOrderBadge = css`
  position: absolute;
  left: 0;
  bottom: 10px;
  z-index: 1;
  color: #f5f5f3;
  font-size: 10px;
  padding: 4px 8px;
  background: #1f1f1f;
`;

export const image = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const noImage = css`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
`;

export const cardBody = css`
  padding: 16px;

  text-align: center;
`;

export const brand = css`
  font-size: 18px;
  color: black;
  // text-transform: uppercase;
  margin-bottom: 6px;
`;

export const name = css`
  font-size: 15px;
  color: black;
  margin-bottom: 8px;
`;

export const price = css`
  font-weight: 600;
  color: black;
`;

export const status = css`
  margin-top: 6px;
  font-size: 12px;
  letter-spacing: 0;
  text-transform: uppercase;
  color: rgba(31, 31, 31, 0.62);
`;
